import * as React from "react";

function SvgIcTag(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5a2 2 0 012-2h6.586A2 2 0 0113 3.586l8 8a2 2 0 010 2.828L14.414 21a2 2 0 01-2.828 0l-8-8A2 2 0 013 11.586V5zm8.586 0H5v6.586l8 8L19.586 13l-8-8z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 9.5a1 1 0 100-2 1 1 0 000 2zm0 1.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcTag;
